import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/home'
import Layout from '@/views/layout/layout'

Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            name: 'layout',
            component: Layout,
            redirect: '/',
            children: [{
                path: '/',
                name: 'home',
                component: home,
            }, 
            {
                path: 'agreement',
                name: 'agreement',
                component: () => import('@/views/agreement/agreement'),
            }, 
            {
                path: '/help',
                name: 'help',
                component: () => import('@/views/agreement/help'),
            }, 
            {
                path: '/declaration',
                name: 'declaration',
                component: () => import('@/views/agreement/declaration'),
            }, 
            {
                path: '/calificacion',
                name: 'calificacion',
                component: () => import('@/views/agreement/calificacion'),  
            }, 
            {
                path: '/condiciones',
                name: 'condiciones',
                component: () => import('@/views/agreement/condiciones'),  
            }
        ]   
        }, 
        // {
        //     path: '/agreement',
        //     name: 'agreement',
        //     component: () => import('@/views/agreement/agreement'),
        // }, 
        // {
        //     path: '/help',
        //     name: 'help',
        //     component: () => import('@/views/agreement/help'),
        // }, 
        // {
        //     path: '/declaration',
        //     name: 'declaration',
        //     component: () => import('@/views/agreement/declaration'),
        // }, 
        // {
        //     path: '/calificacion',
        //     name: 'calificacion',
        //     component: () => import('@/views/agreement/calificacion'),  
        // }, 
        // {
        //     path: '/condiciones',
        //     name: 'condiciones',
        //     component: () => import('@/views/agreement/condiciones'),  
        // }
    ]
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js